export enum TfaType {
  Email = 1,
  Totp = 2,
  WebAuthn = 3,
}
